import { customerService } from '../_services';

export const customer = {
    namespaced: true,
    state: {
        all: [],
        ready: false
    },
    actions: {
        getCustomerCollection({ commit }) {
            commit('getAllRequest');
            return new Promise((resolve, reject) => {
                customerService.getCustomerCollection()
                .then(
                    status => {
                        commit('getAllSuccess', status);
                        resolve(status);
                    },
                    error => {
                        commit('getAllFailure', error);
                        reject(error);
                    }
                );})
        }
    },
    mutations: {
        getAllRequest(state) {
            state.all = { loading: true };
            state.ready = false;
        },
        getAllSuccess(state, status) {
            state.all = status['hydra:member'];
            state.ready = true;
        },
        getAllFailure(state, error) {
            state.all = { error };
            state.ready = false;
        }
    },
    getters: {
        showCustomerCollection(state) {
            return state.all;
        },
        showCustomerByIRI(state) {
            return iri => {
                return state.all.find(obj => obj['@id'] === iri)
            }
        },
        isLoading(state) {
            return (state.all.loading);
        },
        isReady(state) {
            return (state.ready);
        }
    }
};
